<div class="CLoading" :class="cssClass">
  <div class="CLoading__spinner"></div>
</div>
